module.exports = __webpack_public_path__ + "resources/img/guide-hand.322dca31.png";